// The web SDK reports 'permission-denied', React Native Firebase prefixes it with the module name.
const permissionDeniedCodes = [
  'permission-denied',
  'firestore/permission-denied',
];

export const isPermissionDeniedError = (error: unknown): boolean => {
  const code = (error as { code?: unknown } | null)?.code;
  return typeof code === 'string' && permissionDeniedCodes.includes(code);
};
